import { render, staticRenderFns } from "./AddFixedPayment.vue?vue&type=template&id=2be5fb8c&"
import script from "./AddFixedPayment.vue?vue&type=script&lang=js&"
export * from "./AddFixedPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddFixedPayment.vue"
export default component.exports